import { checkVersion } from '@/utils'
let apiTest, webapplink, browerLoggerKey, staticPath
const CUSTOMVERSION = [3, 2, 5] // 需要对比的版本号

// 判断版本号，3.2.5及以上版本用“mingchu.co” 机器是3.2.8，我设置的是3.2.10
const HOST = checkVersion(CUSTOMVERSION) ? 'mingchu.co' : 'greatchef.com.cn'
// const HOST = 'mingchu.co'

// alert(`同步 ${checkVersion(CUSTOMVERSION)} ${HOST}`)
if (process.env.NODE_ENV === 'development') { // 本地开发环境
  apiTest = `http://api.dev.mingchu.co` // 接口地址
  webapplink = `http://m.dev.${HOST}` // 拉app地址，为了和App做版本兼容
  staticPath = '' // CDN资源地址
  browerLoggerKey = 'ifmox@709e786a9393e09' // 阿里云监控密钥
} else if (process.env.NODE_ENV === 'test') { // 测试环境
  apiTest = `https://api.test.mingchu.co`
  webapplink = `http://m.test.${HOST}`
  browerLoggerKey = 'ifmox@afee9bac75d7713'
  staticPath = ''
} else if (process.env.NODE_ENV === 'simulation') { // 仿真环境
  apiTest = `https://api.simulation.mingchu.co`
  webapplink = `http://m.simulation.${HOST}`
  browerLoggerKey = 'ifmox@afee9bac75d7713'
  staticPath = 'https://static.mingchu.co' // CDN资源地址
} else {
  apiTest = 'https://api.mingchu.co' // 线上环境
  webapplink = `https://m.${HOST}`
  browerLoggerKey = 'ifmox@f443542f599fe63'
  staticPath = 'https://static.mingchu.co' // CDN资源地址
}

export default {
  apiTest, webapplink, browerLoggerKey, staticPath
}
